
export enum Chains {
  Solana = 1,
  Algorand = 8,
  Polygon = 5,
  Bsc = 4,
  Avalanche = 6,
  Arbitrum = 23,
  Optimism = 24,
  Base = 30,
  Ethereum = 2,
  Sepolia = 10002,
  ArbitrumSepolia = 10003,
  BaseSepolia = 10004,
  OptimismSepolia = 10005,
  PolygonAmoy = 10007,
}

export const ChainNames = {
  [Chains.Solana]: "Solana",
  [Chains.Ethereum]: "Ethereum",
  [Chains.Polygon]: "Polygon",
  [Chains.Bsc]: "BNB Chain",
  [Chains.Avalanche]: "Avalanche",
  [Chains.Algorand]: "Algorand",
  [Chains.Arbitrum]: "Arbitrum",
  [Chains.Optimism]: "Optimism",
  [Chains.Base]: "Base",
  [Chains.Sepolia]: "Ethereum Sepolia",
  [Chains.ArbitrumSepolia]: "Arbitrum Sepolia",
  [Chains.BaseSepolia]: "Base Sepolia",
  [Chains.OptimismSepolia]: "Optimism Sepolia",
  [Chains.PolygonAmoy]: "Polygon Amoy",
}

export const HTTPSRPC_TESTNET = {
  [Chains.Bsc]: [
    '',
    'https://bsc-testnet.public.blastapi.io',
    'https://bsc-testnet.blockpi.network/v1/rpc/private',
    'https://bsc-testnet-rpc.publicnode.com',
    'https://api.zan.top/bsc-testnet',
    'https://data-seed-prebsc-2-s1.bnbchain.org:8545',
    'https://data-seed-prebsc-2-s2.bnbchain.org:8545',
    'https://data-seed-prebsc-2-s3.bnbchain.org:8545',
    'https://data-seed-prebsc-1-s1.bnbchain.org:8545',
    'https://data-seed-prebsc-1-s2.bnbchain.org:8545',
    'https://data-seed-prebsc-1-s3.bnbchain.org:8545',
    'https://endpoints.omniatech.io/v1/bsc/testnet/public',
  ],
  [Chains.Avalanche]: [
    '',
    'https://rpc.ankr.com/avalanche_fuji',
    'https://rpc.ankr.com/avalanche_fuji-c',
    'https://api.avax-test.network/ext/bc/C/rpc',
    'https://ava-testnet.public.blastapi.io/ext/bc/C/rpc',
    'https://endpoints.omniatech.io/v1/avax/fuji/public',
    'https://avalanche-fuji.blockpi.network/v1/rpc/private',
    'https://avalanche-fuji-c-chain-rpc.publicnode.com',
    'https://avalanche-fuji.blockpi.network/v1/rpc/private',
  ],
  [Chains.Sepolia]: [
    'https://ethereum-sepolia-rpc.publicnode.com',
    'https://sepolia.gateway.tenderly.co',
    'https://eth-sepolia.public.blastapi.io',
    'https://ethereum-sepolia.blockpi.network/v1/rpc/private',
    'https://sepolia.drpc.org',
    'https://endpoints.omniatech.io/v1/eth/sepolia/public',
    'https://1rpc.io/sepolia',
    'https://gateway.tenderly.co/public/sepolia',
    'https://sepolia.gateway.tenderly.co',
    'https://api.zan.top/eth-sepolia',
    'https://ethereum-sepolia.rpc.subquery.network/public',
  ],
  [Chains.ArbitrumSepolia]: [
    '',
    'https://arbitrum-sepolia.blockpi.network/v1/rpc/private ',
    'https://arbitrum-sepolia.gateway.tenderly.co',
    'https://endpoints.omniatech.io/v1/arbitrum/sepolia/public',
    'https://api.zan.top/arb-sepolia',
    'https://sepolia-rollup.arbitrum.io/rpc',
  ],
  [Chains.BaseSepolia]: [
    '',
    'https://sepolia.base.org',
    'https://base-sepolia-rpc.publicnode.com',
    'https://base-sepolia.gateway.tenderly.co',
    'https://base-sepolia.blockpi.network/v1/rpc/private',
    'https://node.histori.xyz/base-sepolia/8ry9f6t9dct1se2hlagxnd9n2a',
  ],
  [Chains.OptimismSepolia]: [
    '',
    'https://optimism-sepolia.blockpi.network/v1/rpc/private',
    'https://sepolia.optimism.io',
    'https://api.zan.top/opt-sepolia',
    'https://optimism-sepolia.gateway.tenderly.co',
    'https://optimism-sepolia.drpc.org',
    'https://endpoints.omniatech.io/v1/op/sepolia/public',
  ],
  [Chains.PolygonAmoy]: [
    'https://rpc-amoy.polygon.technology',
    'https://polygon-amoy-bor-rpc.publicnode.com',
    'https://rpc.ankr.com/polygon_amoy',
    'https://polygon-amoy.drpc.org',
    'https://api.zan.top/polygon-amoy',
    'https://polygon-amoy.gateway.tenderly.co',
  ],
}

export const HTTPSRPC_MAINNET = {
  [Chains.Ethereum]: [
    '',
    'https://eth.llamarpc.com',
    'https://ethereum.blockpi.network/v1/rpc/public',
    'https://eth-mainnet.nodereal.io/v1/1659dfb40aa24bbb8153a677b98064d7',
    'https://uk.rpc.blxrbdn.com',
    'https://singapore.rpc.blxrbdn.com',
    'https://virginia.rpc.blxrbdn.com',
    'https://eth-mainnet.public.blastapi.io',
    'https://api.securerpc.com/v1',
    'https://mainnet.gateway.tenderly.co',
    'https://eth-pokt.nodies.app',
    'https://eth.blockrazor.xyz',
    'https://eth.merkle.io',
    'https://gateway.tenderly.co/public/mainnet',
    'https://eth.rpc.blxrbdn.com',
  ],
  [Chains.Bsc]: [
    '',
    'https://bsc.blockrazor.xyz',
    'https://bscrpc.com',
    'https://bsc-mainnet.public.blastapi.io',
    'https://binance.llamarpc.com',
    'https://go.getblock.io/cc778cdbdf5c4b028ec9456e0e6c0cf3',
    'https://bsc-pokt.nodies.app',
    'https://56.rpc.thirdweb.com',
    'https://bsc.blockpi.network/v1/rpc/private',
    'https://bsc.rpc.blxrbdn.com',
    'https://bsc-dataseed.bnbchain.org',
    'https://endpoints.omniatech.io/v1/bsc/mainnet/public',
    'https://bsc-dataseed1.ninicoin.io',
    'https://bsc-dataseed2.defibit.io',
    'https://bsc-dataseed2.ninicoin.io',
    'https://0.48.club',
    'https://bsc-dataseed3.defibit.io',
  ],
  [Chains.Polygon]: [
    '',
    'https://polygon.llamarpc.com',
    'https://polygon-rpc.com',
    'https://rpc-mainnet.matic.quiknode.pro',
    'https://endpoints.omniatech.io/v1/matic/mainnet/public',
    'https://polygon-pokt.nodies.app',
    'https://polygon-bor-rpc.publicnode.com',
    'https://polygon.rpc.subquery.network/public',
    'https://polygon-bor-rpc.publicnode.com',
    'https://polygon.blockpi.network/v1/rpc/private',
    'https://polygon.api.onfinality.io/public',
    'https://polygon.lava.build',
    'https://api.zan.top/polygon-mainnet',
    'https://polygon.meowrpc.com',
  ],
  [Chains.Avalanche]: [
    '',
    'https://avalanche-c-chain-rpc.publicnode.com',
    'https://ava-mainnet.public.blastapi.io/ext/bc/C/rpc',
    'https://endpoints.omniatech.io/v1/avax/mainnet/public',
    'https://avalanche-c-chain-rpc.publicnode.com',
    'https://avalanche.blockpi.network/v1/rpc/private',
    'https://avalanche.public-rpc.com',
    'https://avalanche.drpc.org',
    'https://avax.meowrpc.com',
    'https://endpoints.omniatech.io/v1/avax/mainnet/public',
    'https://api.avax.network/ext/bc/C/rpc',
    'https://1rpc.io/avax/c',
    'https://avax-pokt.nodies.app/ext/bc/C/rpc',
    'https://endpoints.omniatech.io/v1/avax/mainnet/public',
    'https://api.zan.top/avax-mainnet/ext/bc/C/rpc',
  ],
  [Chains.Arbitrum]: [
    '',
    'https://arbitrum.llamarpc.com',
    'https://arbitrum.rpc.subquery.network/public',
    'https://endpoints.omniatech.io/v1/arbitrum/one/public',
    'https://arbitrum.meowrpc.com',
    'https://arbitrum.gateway.tenderly.co',
    'https://arbitrum-one.public.blastapi.io',
    'https://arb1.lava.build',
    'https://arbitrum-one.publicnode.com',
    'https://arbitrum.blockpi.network/v1/rpc/public',
    'https://arb-pokt.nodies.app',
    'https://api.zan.top/arb-one',
    'https://arb1.arbitrum.io/rpc',
    'https://arbitrum.drpc.org',
    'https://1rpc.io/arb',
  ],
  [Chains.Optimism]: [
    '',
    'https://optimism.llamarpc.com',
    'https://op-pokt.nodies.app',
    'https://optimism-mainnet.public.blastapi.io',
    'https://optimism.blockpi.network/v1/rpc/public',
    'https://endpoints.omniatech.io/v1/op/mainnet/public',
    'https://optimism-rpc.publicnode.com',
    'https://optimism.drpc.org',
    'https://1rpc.io/op',
    'https://optimism.gateway.tenderly.co',
    'https://optimism.lava.build',
    'https://optimism.rpc.subquery.network/public',
    'https://mainnet.optimism.io',
    'https://optimism-rpc.publicnode.com',
    'https://gateway.tenderly.co/public/optimism',
  ],
  [Chains.Base]: [
    '',
    'https://base.llamarpc.com',
    'https://base-mainnet.public.blastapi.io',
    'https://base-rpc.publicnode.com',
    'https://base.blockpi.network/v1/rpc/public',
    'https://base.drpc.org',
    'https://mainnet.base.org',
    'https://base.api.onfinality.io/public',
    'https://base-pokt.nodies.app',
    'https://1rpc.io/base',
    'https://developer-access-mainnet.base.org',
    'https://endpoints.omniatech.io/v1/base/mainnet/public',
    'https://base.rpc.subquery.network/public',
    'https://base.api.onfinality.io/public',
    'https://base.meowrpc.com',
    'https://base.gateway.tenderly.co',
  ],
}

